<div class="outer-div flex-row-s h-100" *ngIf="!isPDF">
    <ol class="breadcrumbs"  *ngIf="!showTitle">
      <li>
        <span class="breadcrumb">
          {{'Title' | translate}}
        </span>
      </li>
      <li *ngIf="smallScreen && currentPath.length > 2">
        <span class="breadcrumb">
          {{"..."}}
        </span>
      </li>
      <li *ngFor="let p of currentPath" >
        <a class="breadcrumb" *ngIf="p.url !== ''" [routerLink]="p.url" >{{p.text || (p.key || '' |
          translate)}}</a>
        <span class="breadcrumb" *ngIf="p.url === ''">{{p.text || (p.key || '' |
          translate)}}</span>
      </li>
    </ol>
    <span class="breadcrumb" *ngIf="showTitle">{{currentPath.at(-1) && currentPath.at(-1).text || (currentPath.at(-1) && currentPath.at(-1).key || '' |
    translate)}}</span>
</div>
